// Class: post-type-archive-projetos
import MasonryComponent from '../components/masonry';

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {
    new MasonryComponent();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/projetos.js